<template>
  <div class="enrolling-pass-student">
    <PlatDataGridSiteUnit grid-id="PeEnrollPassStudent"
                          show-label></PlatDataGridSiteUnit>
  </div>
</template>

<script>
import PlatDataGridSiteUnit from '../../../wrapper/grid/PlatDataGridSiteUnit'
export default {
  name: 'EnrollingPassStudent',
  components: {
    PlatDataGridSiteUnit
  }
}
</script>

<style lang="scss">
  .enrolling-pass-student {
    height: 100%;
  }
</style>
